import scrollTo from '../../../../Public/Frontend/src/js/scroll-to.js';

;(function () {
    const scrollButtons = document.querySelector('.scroll-buttons');
    if (!scrollButtons) {
        return;
    }

    // if there's only one visible element, hide scroll buttons
    if ($('.mod_article').length === 1 && $('.mod_article > div:not(.hide)').length <= 1) {
        scrollButtons.remove();
        return;
    }

    /**
     * Find the first element which start is visible at current scroll position
     * @type {boolean}
     */
    let contentElements = false;

    function getVisibleContentElementIndex() {
        const fixedHeaderSpacing = jQuery('body').width() < 767 ? 0 : jQuery('header').outerHeight();
        const scrollTop = jQuery('html,body').scrollTop();
        contentElements = contentElements || $('.mod_article').children().not('.ce_rsce_news_teaser');

        return Array.from(contentElements).findIndex(function (item) {
            return ($(item).offset().top - scrollTop - fixedHeaderSpacing) > -1;
        });
    }

    // scroll buttons
    $('.scroll-buttons .prev-button').click(function () {
        // edge case, if we are scrolled below the last element start
        const fixedHeaderSpacing = jQuery('body').width() < 767 ? 0 : jQuery('header').outerHeight();
        const scrollTop = jQuery('html,body').scrollTop();
        contentElements = contentElements || $('.mod_article').children().not('.ce_rsce_news_teaser');
        const lastElement = contentElements[contentElements.length - 1];
        const lastElementStart = $(lastElement).offset().top - scrollTop - fixedHeaderSpacing;
        if (lastElementStart < 0) { // after last element start
            if (lastElementStart > -5) {
                // just a little unsharp, scroll one element up
                scrollTo(contentElements[contentElements.length - 2]);
                return
            } else {
                // scroll till last element start
                scrollTo(contentElements[contentElements.length - 1]);
                return;
            }
        }

        // find the previous element and scroll there
        const prevElement = contentElements[getVisibleContentElementIndex() - 1];
        if (prevElement) scrollTo(prevElement);
    });

    $('.scroll-buttons .next-button').click(function () {
        // find the next element and scroll there
        const index = getVisibleContentElementIndex();
        const nextElement = contentElements[index + 1];
        if (nextElement) scrollTo(nextElement);
    });
})();
